export const TARIFFS = {
  ONE: {
    label: '1 мес.',
    value: 'ONE',
    price: 5000,
  },
  THREE_PLUS_ONE: {
    label: '3 (2+1) мес.',
    value: 'TWO_PLUS_ONE',
    price: 10000,
  },
  SIX_PLUS_SIX: {
    label: 'Бессрочно',
    value: 'SIX_PLUS_SIX',
    price: 15000,
  },
};

export const MODES = {
  NORMAL: {
    label: '1 урок в день',
    value: 'NORMAL',
  },
  REINFORCED: {
    label: '2 урок в день',
    value: 'REINFORCED',
  },
  HYPER: {
    label: '3 урок в день',
    value: 'HYPER',
  },
  INFINITE: {
    label: 'Без ограничений',
    value: 'INFINITE',
  },
};
